(function () {
    window.sessionStorage.setItem(
        "shoppableRecipeConfig",
        JSON.stringify({
            identifiers: {
                ingredientsContainerClassName: "c-recipe-content-ingredients",
                ingredientItemClassName: "c-recipe-content-ingredients__list-item",
            },
            colors: {
                primary: "#0C456E",
                secondary: "#ffffff",
            },
            cta: {
                borderRadius: "4px",
                fontSize: "1.125rem",
                padding: "0.5rem 1.875rem",
                margin:"0",
                height: "auto",
                shareIcon: {
                    contents: "",
                    base64Encoded: false,
                },
                alignment: "left"
            },
            labels: {
                shareTitle: "Add to Shopping List or Share",
                intro: "Sharing ingredients list for",
                closingRemarks: "See full cooking instructions at"
            },
        })
    );

    var scriptURL = "production" === process.env.NODE_ENV ? "https://shoppablerecipe-widget-prod.unileversolutions.com/build/shoppable_recipe_widget_v1.js" : "https://shoppablerecipe-widget-stg.unileversolutions.com/build/shoppable_recipe_widget_v1.js";

    var scriptElement = document.createElement("script");

    scriptElement.setAttribute("defer", "defer");

    scriptElement.setAttribute("src", scriptURL);

    document.body.appendChild(scriptElement);
})();